import formValidation from '../../../../../../mixins/validable';
import { getBiztNameById, MINDEN_BIZTOSITO } from '../../../../../../modules/Biztosito';

export default {

    mixins: [formValidation],
    data() {
        return {
            visible: true,
            propName: '',
        };
    },
    props: {
        biztositoid: {
            type: Number,
            required: true,
            validator: (v) => MINDEN_BIZTOSITO.includes(v),
        },
        titleExtra: {
            type: String,
            required: true,
        },
    },
    mounted() {
        // this.visible = this.getFieldCount() > 0
        this.propName = getBiztNameById(this.biztositoid);
        if (this.$store.getters.tarifaData[this.propName] == null) {
            this.$store.commit('setProp', {
                path: `tarifaData.${this.propName}`,
                value: {},
            });
        }
    },
    methods: {
        getFieldCount() {
            return this.$refs['casco-kgfb-adatok'].$el.length;
        },

        validate() {
            return this.validateForms(['casco-kgfb-adatok']);
        },
    },

    computed: {
        kedvezmenyek() {
            return this.$store.getters.cascokedvezmenyek[this.biztositoid];
        },
    },
};
